import { useAuth } from "@/hooks/useAuth";
// Kita tetap import tipe ini agar komponen lain tidak error (TypeScript senang)
import type { UserContextType } from "@/context/UserContext";

export function useUser(): UserContextType {
    // 1. Ambil data dari sumber baru (Instan dari Memory/LocalStorage)
    const { user, loading } = useAuth();

    // 2. Buat objek palsu yang strukturnya MIRIP dengan React Query (UserContextType)
    // Ini disebut pattern "Adapter".
    const adaptedResult = {
        data: user,          // ✅ Mapping: 'user' jadi 'data'
        isLoading: loading,  // ✅ Mapping: 'loading' jadi 'isLoading'

        // Properti Dummy (Pura-pura) agar tidak error
        isError: false,
        isSuccess: !!user,
        error: null,
        status: loading ? "pending" : "success",
        fetchStatus: "idle",
        refetch: async () => { return { data: user } }, // Dummy function
        isFetching: false,
        dataUpdatedAt: Date.now(),
        // ... properti lain tidak terlalu penting
    };

    // 3. Kembalikan sebagai UserContextType
    // Kita paksa tipe datanya (casting) agar TypeScript tidak protes properti yang kurang
    return adaptedResult as unknown as UserContextType;
}

// import { useContext } from "react";
// import { UserContext } from "@/context/UserContext";
// import type { UserContextType } from "@/context/UserContext";

// export function useUser(): UserContextType {
//     const context = useContext(UserContext);
//     if (!context) {
//         throw new Error("useUser must be used within a UserProvider");
//     }
//     return context;
// }
